/* global google */

/**
 * Create a custom Popup element to be displayed on a Google Map
 * Inspired by https://developers.google.com/maps/documentation/javascript/examples/overlay-popup
 *
 * Usage:
 * const popup = new Popup({ lat: 0, lng: 0 });
 * popup.setMap(map);
 *
 * When you set the map, the `onAdd` method below will be called followed by `draw`.
 *
 * To remove the popup, unset the map with:
 * popup.setMap(null);
 *
 * @param {object} position { lat, lng }
 * @extends google.maps.OverlayView
 */
export default function createPopup(position) {
  function Popup() {
    this.position = position;

    this.container = document.createElement('div');
    this.container.style.position = 'absolute';

    this.popupNode = document.createElement('div');
    this.container.appendChild(this.popupNode);

    google.maps.OverlayView.preventMapHitsAndGesturesFrom(this.container);
  }

  Popup.prototype = Object.create(google.maps.OverlayView.prototype);

  Popup.prototype.setPosition = function(position) {
    this.position = position;
  };

  Popup.prototype.onAdd = function() {
    this.getPanes().floatPane.appendChild(this.container);
  };

  Popup.prototype.onRemove = function() {
    if (this.container.parentElement) {
      this.container.parentElement.removeChild(this.container);
    }
  };

  Popup.prototype.draw = function() {
    const divPosition = this.getProjection().fromLatLngToDivPixel(
      this.position
    );
    const rect = this.container.getBoundingClientRect();

    this.container.style.left = divPosition.x - rect.width / 2 + 'px';
    // 20 is the space we want between the marker and the popup
    this.container.style.top = divPosition.y - rect.height - 20 + 'px';
  };

  return new Popup();
}
